import { FormConsentDropdownValues } from "@/components/site-builder/modules/CustomFormModule/constants";
import {
  FormBuilderConsentFieldNames,
  FormBuilderConsentInputType,
} from "@/constants/form-builder";
import type { FormBuilderConsentConfig } from "@/types/form-builder";

const getConsentDefaultValue = (
  type: FormBuilderConsentInputType,
  selectedByDefault: boolean,
) => {
  if (type === FormBuilderConsentInputType.Dropdown) {
    return selectedByDefault ? FormConsentDropdownValues.Yes : "";
  }

  return selectedByDefault;
};

export function getConsentDefaultValues(config: FormBuilderConsentConfig) {
  const { combined, marketing, thirdParty } = config;

  const defaultValues: Partial<
    Record<FormBuilderConsentFieldNames, string | boolean | null>
  > = {};

  if (combined.shown) {
    defaultValues[FormBuilderConsentFieldNames.CombineMarketing] =
      getConsentDefaultValue(combined.inputType, combined.selectedByDefault);
  }

  if (thirdParty.shown && thirdParty.text) {
    defaultValues[FormBuilderConsentFieldNames.ThirdParty] =
      getConsentDefaultValue(
        thirdParty.inputType,
        thirdParty.selectedByDefault,
      );
  }

  if (marketing.shown && marketing.text) {
    defaultValues[FormBuilderConsentFieldNames.Marketing] =
      getConsentDefaultValue(marketing.inputType, marketing.selectedByDefault);
  }

  return defaultValues;
}
